export default __webpack_public_path__ + "static/media/star_rate_icon.7fffc69c.svg";